/**
 * Warm the code-split chunks for the routes an operator is most likely
 * to open next (catalog, barrel detail, tasting form, scanner) so the
 * first tap navigates instantly instead of waiting on a chunk download.
 *
 * Vite dedupes dynamic imports by specifier, so these resolve to the
 * exact same chunks App.tsx's lazy() routes use — the import just lands
 * them in the module cache early. Fired once per session from the
 * authed Layout, on idle so it never competes with first paint.
 * Fire-and-forget: a failed prefetch costs nothing (the route loads
 * normally on navigation).
 */

let fired = false;

export function prefetchLikelyRoutes(): void {
  if (fired) return;
  fired = true;

  const run = () => {
    void import('../pages/BarrelCatalog').catch(() => {});
    void import('../pages/BarrelDetail').catch(() => {});
    void import('../pages/TastingLog').catch(() => {});
    void import('../pages/QRScanner').catch(() => {});
  };

  const w = window as Window & {
    requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number;
  };
  if (typeof w.requestIdleCallback === 'function') {
    w.requestIdleCallback(run, { timeout: 5000 });
  } else {
    // Safari has no requestIdleCallback — a short delay clears first paint.
    setTimeout(run, 2500);
  }
}
